import React__default from 'react';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { LeadSourcePageType } from '../../../generated/types.js';
import { conversationStarterRichCard } from '../../../services/richCardFactory.js';
import { ConversationStarterActivityForRichCardComponent } from './ConversationStarterMessage.generated.js';
import SellableDetailPage from './SellableDetailPage/index.js';
import Default from './Default/index.js';
import SellableTopListPage from './SellableTopListPage/index.js';
import SellableSearchPage from './SellableSearchPage/index.js';

var ConversationStarterMessage = function ConversationStarterMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCard = conversationStarterRichCard(message);
  return React__default.createElement(ConversationStarterActivityForRichCardComponent, {
    variables: {
      leadId: richCard.leadId,
      conversationStarterActivityId: richCard.leadConversationStarterActivityId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    var _b;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    }

    if ((_b = data === null || data === void 0 ? void 0 : data.lead) === null || _b === void 0 ? void 0 : _b.conversationStarterActivity) {
      var sourcePage = data.lead.conversationStarterActivity.sourcePage;
      var conversationStarterMessage = data.lead.conversationStarterActivity.message;

      switch (sourcePage === null || sourcePage === void 0 ? void 0 : sourcePage.type) {
        case LeadSourcePageType.SELLABLE_DETAIL:
          return React__default.createElement(SellableDetailPage, {
            message: message,
            sourcePage: sourcePage,
            conversationStarterMessage: conversationStarterMessage
          });

        case LeadSourcePageType.SELLABLE_TOP_LIST:
          return React__default.createElement(SellableTopListPage, {
            message: message,
            sourcePage: sourcePage,
            conversationStarterMessage: conversationStarterMessage
          });

        case LeadSourcePageType.SELLABLE_SEARCH:
          return React__default.createElement(SellableSearchPage, {
            message: message,
            sourcePage: sourcePage,
            conversationStarterMessage: conversationStarterMessage
          });

        default:
          return React__default.createElement(Default, {
            message: message,
            conversationStarterMessage: conversationStarterMessage
          });
      }
    } else {
      // The conversation starter has expired
      return null;
    }
  });
};

ConversationStarterMessage.handlesMessage = function (message) {
  return !!conversationStarterRichCard(message);
};

export default ConversationStarterMessage;
//# sourceMappingURL=index.js.map
